import { Box, Button, Chip, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../../../store/UserStore";

const Logout = () => {
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);
  const setUser = useUserStore((state) => state.setUser);

  useEffect(() => {
    const removeSessionHandler = async () => {
      try {
        const response = await fetch("https://rawdat.ai/login/portal/logout", {
          method: "GET",
          credentials: "include",
        });

        if (response.ok) {
          setUser(null);
          if (localStorage.getItem("rawdat-session")) {
            localStorage.removeItem("rawdat-session");
          }
          navigate("/login");
          //window.location.reload();
        }
      } catch (error) {
        console.error("Not able to remove session");
      }
    };

    if (user) {
      removeSessionHandler();
    }
  }, [user]);
  const loginBtnHandler = () => {
    navigate("/login");
  };
  return (
    <Box
      sx={{
        height: "calc(100lvh - 80px)",
        overflow: "hidden",
        background: "linear-gradient(180deg, #000 38%, #1D6BAE 100%);",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1.5rem",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={2}
      >
        <Typography variant="h5" color={"common.white"}>
          You have logged out!
        </Typography>

        <Chip
          variant={"filled"}
          color="primary"
          label={"Go to Log in"}
          sx={{ width: "250px", cursor: "pointer", height: "40px" }}
          onClick={loginBtnHandler}
        />
      </Box>
    </Box>
  );
};

export default Logout;
